import request from '@shared/innmaxLib/services'
import { compose, forEach, pathOr } from 'ramda'
import React from 'react'
import { useQuery } from 'react-query'
import { getUserRoleEnum, useAuth } from '.'
import type { IUser } from '../user'
import type { MenuAuth, UserPermission } from './auth.types'
import { setUserAuth } from './useLogin'

export const useMineInfo = (options?: {
  displayError?: boolean
  onSuccess?: (response: any) => void
}) => {
  const { setIsAuthenticated, setUser, user } = useAuth()

  const { displayError = true, onSuccess } = options || {}

  const { refetch, isLoading, data, isFetched } = useQuery(
    ['/account/mineInfo'],
    () =>
      request('/account/mineInfo', {
        method: 'GET',
        displayError,
      }),
    {
      cacheTime: Infinity,
      refetchOnMount: false,
      enabled: false,
      onSuccess: (response: any) => {
        if (!response) {
          return
        }

        let authById: { [key: string]: UserPermission } = {}
        let authByUrl: { [key: string]: UserPermission } = {}

        compose(
          forEach((x: MenuAuth) => {
            authById[x.name] = setUserAuth(x, authById[x.name])
            authByUrl[x.webPath] = setUserAuth(x, authByUrl[x.webPath])
          }),
          pathOr([], ['data', 'roleObj', 'authDetails'])
        )(response)

        const funcList = Object.keys(authById).map(i => authById[i])

        setIsAuthenticated(true)

        setUser({
          ...response?.data,
          authById,
          authByUrl,
          funcList,
          role: getUserRoleEnum(response?.data?.roleObj?.id),
        })
        onSuccess?.(response?.data)
      },
    }
  )

  const dataSource = React.useMemo(
    () => pathOr<IUser | undefined>(undefined, ['data'], data),
    [data]
  )

  return { refetch, isLoading, dataSource, isFetched }
}
